"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _image = _interopRequireDefault(require("../image"));
var mapInspirationPage = function mapInspirationPage(inspirationPageSlice, bloggerData) {
  if (!inspirationPageSlice || inspirationPageSlice.length === 0) return false;
  var inspirationPage = [];
  inspirationPageSlice.map(function (slice) {
    var inspirationPageImages = [];
    slice === null || slice === void 0 ? void 0 : slice.items.map(function (image) {
      var _image$blurhash;
      inspirationPageImages.push({
        image: (0, _image["default"])(image.image, ((_image$blurhash = image.blurhash) === null || _image$blurhash === void 0 ? void 0 : _image$blurhash.length) > 0 && image.blurhash[0].text)
      });
    });
    inspirationPage.push({
      bloggerId: bloggerData,
      images: inspirationPageImages
    });
  });
  return inspirationPage;
};
var _default = mapInspirationPage;
exports["default"] = _default;